import useStyles from './styles';
import { Box } from '@mui/system';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import InputConfig from '../../../../Components/InputConfig';
import { ACCESS_CONTROL_CONSTANTS } from '../../../../core/constants';
import useCommonStyles from '../../../../commonStyles';
const { SYSTEMS } = ACCESS_CONTROL_CONSTANTS;

const VideoSectionSplitCard = ({
	videoSections,
	videoSectionId,
	sectionSplitData,
	updateSplitPercentage,
	deleteSectionFromSplitConfig,
	keyData
}) => {
	const classes = useStyles();
	const adsSection = videoSections[videoSectionId];
	const commonStyleClasses = useCommonStyles();
	return (
		<Box className={commonStyleClasses.basicOutlinedBox} style={{ width: '95%' }}>
			{videoSectionId && sectionSplitData && (
				<>
					<Box style={{ width: '100%' }}>
						<InputConfig
							system={SYSTEMS.FVP_PLAYER}
							label="Section Name"
							isObjectEditor={false}
							keyData={keyData + `.sectionName`}
							directValue={adsSection.videoSectionName}
							editable={false}
							inputStyles={{ width: '100%', margin: '1rem 0' }}
							labelStyles={{ display: 'flex', justifyContent: 'center', width: '90%' }}
						/>
					</Box>

					<Box style={{ width: '100%' }}>
						<InputConfig
							system={SYSTEMS.FVP_PLAYER}
							label="Split Percentage"
							isObjectEditor={false}
							inputType="number"
							keyData={keyData + `.splitPercentage`}
							directValue={sectionSplitData.splitPercentage}
							updateDirectValue={(value) => updateSplitPercentage(videoSectionId, Number(value))}
							inputStyles={{ width: '100%', margin: '1rem 0' }}
							labelStyles={{ display: 'flex', justifyContent: 'center', width: '90%' }}
							inputProps={{ min: '0', max: '100', step: '1' }}
						/>
						<Box style={{ marginTop: '2rem' }}>
							<DeleteOutlinedIcon
								color="primary"
								onClick={() => deleteSectionFromSplitConfig(videoSectionId)}
								className={classes.icon}
							/>
						</Box>
					</Box>
				</>
			)}
		</Box>
	);
};

export default VideoSectionSplitCard;
